export const videoHotlineConstants = {

	VideoHotlineGetByfilterRequest: "HOTLINE_VIDEO_GET_BYFILTER_STARTED",
	VideoHotlineGetByfilterSuccess: "HOTLINE_VIDEO_GET_BYFILTER_COMPLETED",
	VideoHotlineGetByfilterFailure: "HOTLINE_VIDEO_GET_BYFILTER_FAILED",

	VideoHotlineDetailRequest: "HOTLINE_VIDEO_GET_DETAIL_STARTED",
	VideoHotlineDetailSuccess: "HOTLINE_VIDEO_GET_DETAIL_COMPLETED",
	VideoHotlineDetailFailure: "HOTLINE_VIDEO_GET_DETAIL_FAILED",
	
	GetMessageBoardIDRequest: "GET_MESSAGE_BOARD_ID_STARTED",
	GetMessageBoardIDSuccess: "GET_MESSAGE_BOARD_ID_COMPLETED",
	GetMessageBoardIDFailure: "GET_MESSAGE_BOARD_ID_FAILED",

	VideoHotlineDeleteRequest: "HOTLINE_VIDEO_DELETE_STARTED",
	VideoHotlineDeleteSuccess: "HOTLINE_VIDEO_DELETE_COMPLETED",
	VideoHotlineDeleteFailure: "HOTLINE_VIDEO_DELETE_FAILED",
}